import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TestScheduleService } from "src/app/shared";
import Swal from "sweetalert2";
import * as moment from "moment";
import { first } from "rxjs/operators";

@Component({
  selector: "app-upload-test-schedule",
  templateUrl: "./upload-test-schedule.component.html",
  styleUrls: ["./upload-test-schedule.component.scss"]
})
export class UploadTestScheduleComponent implements OnInit {
  testSchedule: any = [];
  sender = "upload-test-schedule";
  filter: any = {
    key: ""
  };

  /*** for paginaton start */
  pageSize = 25;
  currentPage = 1;
  testCount = 0;
  doc: any;
  downloadurl = "";
  /** end pagination */

  constructor(
    private testScheduleService: TestScheduleService,
    private router: Router
  ) { }

  ngOnInit() {
    this.searchTestSchedule();
  }

  searchTestSchedule() {
    this.testScheduleService
      .searchTestSchedules(this.currentPage, this.pageSize, this.filter)
      .pipe(first())
      .subscribe(res => {
        this.testCount = res["count"];
        this.testSchedule = res["data"];
      });
  }

  getTime(xtime) {
    if (xtime) {
      return moment(xtime).format("hh:mm A");
    } else {
      return "";
    }
  }

  fetchexamData(e) {
    this.currentPage = e;
    this.searchTestSchedule();
  }

  clear() {
    this.filter.key = "";
    this.searchTestSchedule();
  }

  uploadTestSchedule() {
    this.router.navigate(["manager/test-schedule/upload"]);
  }

  onClick(id) {
    this.router.navigate(["manager/candidate-schedule/" + id]);
  }

  onAdd() {
    this.router.navigate(["manager/candidate-schedule/new"]);
  }

  onDelete() {
    Swal.fire({
      title: "Are you sure?",
      text:
        "Candidate Schedule data will be deleted. This action can't be reversed!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it"
    }).then(result => {
      if (result.value) {
        Swal.fire("Deleted!", "Candidate Schedule is deleted.", "success");
        this.testScheduleService
          .deleteAll(this.testSchedule)
          .pipe(first())
          .subscribe(res => {
            this.searchTestSchedule();
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelled", "Candidate Schedule is Not Deleted:)", "error");
      }
    });
  }
}
